import { render, staticRenderFns } from "./systemnotification.vue?vue&type=template&id=2c75baf2&scoped=true&"
import script from "./systemnotification.vue?vue&type=script&lang=js&"
export * from "./systemnotification.vue?vue&type=script&lang=js&"
import style0 from "./systemnotification.vue?vue&type=style&index=0&id=2c75baf2&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c75baf2",
  null
  
)

export default component.exports